import React from 'react';
import BackButton from './BackButton';

/** Default page back control — uses browser history unless an explicit `to` is passed. */
const PageBackBar = ({ to, className = '' }) => {
    return <BackButton to={to} className={className} />;
};

export default PageBackBar;
